module.exports = __webpack_public_path__ + "img/WaterGuru-Logo-Blue.7166f91c.svg";